import * as R from 'ramda';


/**
 * List of browsers that exist in the world. E.g. Chrome/Edge/IE/FF...
 */
export enum BROWSER {
  CHROME,
  FIRE_FOX,
  SAFARI,
  OPERA,
  OLD_IE,
  IE11,
  EDGE,
  UNKNOWN,
}


/**
 * Parses a user agent string to figure out which browser the user is using.
 */
export const parseUserAgent = (agent: string): BROWSER => {
  /* The order matters! Many browsers declare compatibility with Chrome/Safari by listing it in the user agent e.g. */

  if (agent.indexOf('Firefox') > 0) {
    return BROWSER.FIRE_FOX; // Unique
  }

  if (agent.indexOf('Opera') > 0) {
    return BROWSER.OPERA; // Unique
  }

  if (agent.indexOf('MSIE ') > 0) {
    return BROWSER.OLD_IE; // Unique
  }

  if (agent.indexOf('Trident/') > 0) {
    return BROWSER.IE11; // Unique
  }

  if (agent.indexOf('Edge/') > 0) {
    return BROWSER.EDGE; // Unique
  }

  if (agent.indexOf('Chrome') > 0) {
    return BROWSER.CHROME; // Very not unique
  }

  if (agent.indexOf('Safari') > 0) {
    return BROWSER.SAFARI; // Chrome inexplicably has Safari in its agent string
  }

  return BROWSER.UNKNOWN;
};


/**
 * Reads the browser's user agent string and returns the browser the user is using.
 */
export const getBrowser = (): BROWSER => parseUserAgent(window.navigator.userAgent);


/**
 * Returns a boolean for whether or not the current browser is IE.
 */
export const onIe = (): boolean => R.includes(getBrowser(), [ BROWSER.IE11, BROWSER.OLD_IE ]);
